import React, { useState } from 'react';
import './PriceCalculator.css'; // Ensure proper styling

const PriceCalculator = () => {
  const [plan, setPlan] = useState('Silver Plan'); // Default plan
  const [numPractitioners, setNumPractitioners] = useState(1); // Start with 1 practitioner
  const [numAppointments, setNumAppointments] = useState(20); // Default number for Silver Plan
  const [advancedScheduling, setAdvancedScheduling] = useState(false);
  const [groupAppointments, setGroupAppointments] = useState(false);

  const basePrices = {
    'Silver Plan': 54,
    'Gold Plan': 79,
    'Platinum Plan': 99,
  };

  // Pricing Logic
  const calculatePrice = () => {
    let totalPrice = basePrices[plan];

    // Calculate extra costs for practitioners (after the first one)
    if (numPractitioners > 1) {
      totalPrice += (numPractitioners - 1) * 10;
    }

    // Additional appointment costs for Silver Plan (over 20 appointments)
    if (plan === 'Silver Plan' && numAppointments > 20) {
      totalPrice += (numAppointments - 20) * 15;
    }

    // Advanced scheduling adds CAD $20
    if (advancedScheduling) {
      totalPrice += 20;
    }

    // Group appointments add CAD $15 per practitioner
    if (groupAppointments) {
      totalPrice += numPractitioners * 15;
    }

    return totalPrice;
  };

  return (
    <div className="price-calculator">
      <h3 className='plan-selection-header'style={{color:'#1d3557'}}>Calculate Your Monthly Rate</h3>
      
      {/* Plan Selection */}
      <div className="plan-selection">
        <label>Choose a plan:</label>
        <div className="plan-options">
            <label 
            className={`plan-option ${plan === 'Silver Plan' ? 'selected' : ''}`}
            onClick={() => setPlan('Silver Plan')}
            >
            <input 
                type="radio" 
                name="plan" 
                value="Silver Plan" 
                checked={plan === 'Silver Plan'} 
                onChange={() => setPlan('Silver Plan')} 
            />
            Silver Plan (CAD $54/month)
            </label>
            <label 
            className={`plan-option ${plan === 'Gold Plan' ? 'selected' : ''}`}
            onClick={() => setPlan('Gold Plan')}
            >
            <input 
                type="radio" 
                name="plan" 
                value="Gold Plan" 
                checked={plan === 'Gold Plan'} 
                onChange={() => setPlan('Gold Plan')} 
            />
            Gold Plan (CAD $79/month)
            </label>
            <label 
            className={`plan-option ${plan === 'Platinum Plan' ? 'selected' : ''}`}
            onClick={() => setPlan('Platinum Plan')}
            >
            <input 
                type="radio" 
                name="plan" 
                value="Platinum Plan" 
                checked={plan === 'Platinum Plan'} 
                onChange={() => setPlan('Platinum Plan')} 
            />
            Platinum Plan (CAD $99/month)
        </label>
        </div>
      </div>


      {/* Practitioners and Appointments */}
      <div className="calculator-fields">
        <div className="form-field">
            <label>
            Number of Practitioners:
            <input 
                type="number" 
                value={numPractitioners} 
                onChange={(e) => setNumPractitioners(Number(e.target.value))} 
                min="1" 
            />
            {/* <span className="tooltip">This includes full-time and part-time practitioners</span> */}
            </label>
        </div>

        {plan === 'Silver Plan' && (
            <div className="form-field">
            <label>
                Number of Appointments:
                <input 
                type="number" 
                value={numAppointments} 
                onChange={(e) => setNumAppointments(Number(e.target.value))} 
                min="0" 
                />
                {/* <span className="tooltip">Extra cost per appointment beyond 20</span> */}
            </label>
            </div>
        )}

        <div className="form-field">
            <label>
            Advanced Scheduling:
            <input 
                type="checkbox" 
                checked={advancedScheduling} 
                onChange={(e) => setAdvancedScheduling(e.target.checked)} 
            />
            {/* <span className="tooltip">Adds CAD $20 for advanced scheduling features</span> */}
            </label>
        </div>

        <div className="form-field">
            <label>
            Group Appointments (CAD + $15 / practitioner):
            <input 
                type="checkbox" 
                checked={groupAppointments} 
                onChange={(e) => setGroupAppointments(e.target.checked)} 
            />
            {/* <span className="tooltip">Extra cost for group bookings</span> */}
            </label>
        </div>
        </div>

      {/* Estimated Price */}
        <div className="price-display">
            <h4>Your estimated price: CAD ${calculatePrice()}/month</h4>
        </div>

      {/* Reset Button */}
      <button className="reset-btn" onClick={() => {
        setPlan('Silver Plan');
        setNumPractitioners(1);
        setNumAppointments(20);
        setAdvancedScheduling(false);
        setGroupAppointments(false);
      }}>
        Reset Calculator
      </button>
    </div>
  );
};

export default PriceCalculator;
